require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-2025-afdb-cso-forum-and-annual-meetings.json") })
        }
      }, "path---en-us-update-2025-afdb-cso-forum-and-annual-meetings");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-2025-afdb-cso-forum-and-annual-meetings!./.cache/json/en-us-update-2025-afdb-cso-forum-and-annual-meetings.json
// module id = 601
// module chunks = 231608221292675